<template>
  <container :timeOut="timeOut" :verticalExpansion="verticalExpansion">
    <div 
      :class="{[defaultClass]: defaultClass}"
      style="cursor: pointer;"
      @click="() => {
        isExpanded = !isExpanded
        $emit('click')
      }" 
    >
      <slot name="default"></slot>
    </div>

    <div v-if="isExpanded" :class="{'fade-in': isExpanded && animation !== 0}">
      <slot name="expanded"></slot>
    </div>
  </container>
</template>

<script>
import Container from './Container.vue'

export default {
  name: 'MenuExpansionSection',
  props: {
    value: {type: Boolean, required: true},
    timeOut: {type: Number, default: 0},
    verticalExpansion: {type: Boolean, default: true},
    defaultClass: {type: String}
  },
  components: { Container },

  computed: {
    isExpanded: {
      get () { return this.value },
      set (v) { 
        return this.$emit('input', v) 
      }
    }
  },

  data: () => ({
    animation: 0
  }),

  watch: {
    isExpanded () { this.animation++ }
  },
}
</script>

<style scoped>
  .fade-in {
    opacity: 0;
    animation: fadeIn 0.3s ease-in forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-out {
    opacity: 1;
    animation: fadeOut 0.3s ease-out forwards;
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }  
</style>
